import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getClientsPageTokens } from '../getClientsPageTokens';
import { CLIENT_ROW_HEIGHT_PX, CLIENTS_PAGE_LAYOUT_SIZES } from '../clientsTokens';

export interface ClientListItemProps {
  isPersonal: boolean;
  isSelected: boolean;
  memberCount: number;
  name: string;
  onSelect: () => void;
}

export function ClientListItem({
  isPersonal,
  isSelected,
  memberCount,
  name,
  onSelect,
}: ClientListItemProps): JSX.Element {
  const theme = useTheme();
  const tokens = getClientsPageTokens(theme);

  return (
    <Box
      component="button"
      type="button"
      onClick={onSelect}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        minHeight: CLIENT_ROW_HEIGHT_PX,
        px: 1.5,
        py: 0.75,
        border: 'none',
        borderRadius: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarFieldRadius}px`,
        cursor: 'pointer',
        textAlign: 'left',
        bgcolor: isSelected ? tokens.listItemSelectedBg : 'transparent',
        color: isSelected ? tokens.listItemSelectedColor : tokens.pageHeadingColor,
        transition: 'background-color 0.15s ease',
        '&:hover': {
          bgcolor: isSelected ? tokens.listItemSelectedBg : tokens.listItemHoverBg,
        },
      }}
    >
      <Typography
        variant="body2"
        noWrap
        sx={{
          fontWeight: 600,
          width: '100%',
          color: 'inherit',
        }}
      >
        {name}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: isSelected ? tokens.listItemSelectedColor : tokens.bodySecondaryColor,
          opacity: isSelected ? 0.85 : 1,
        }}
      >
        {memberCount} member{memberCount === 1 ? '' : 's'}
        {isPersonal ? ' · Playground' : ''}
      </Typography>
    </Box>
  );
}
